"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recordTerminalPaymentOutcome = exports.getPaymentLink = exports.createCommand = exports.API_URI = void 0;
const API_URI = exports.API_URI = typeof process !== 'undefined' && process.env?.REACT_APP_API_URI ? process.env.REACT_APP_API_URI : 'https://kiosk-pluracore-60922b42b03b.herokuapp.com';
const createCommand = async (project_id, user_datas, products) => {
  const command = await fetch(`${API_URI}/commands/${project_id}`, {
    method: 'POST',
    body: JSON.stringify({
      user_datas
    }),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const commandData = await command.json().catch(() => ({}));
  if (!command.ok) {
    throw new Error(commandData.message || 'Erreur lors de la création de la commande');
  }
  for (const product of products) {
    await fetch(`${API_URI}/commands/${commandData.id}/quantity`, {
      method: 'PUT',
      body: JSON.stringify({
        product_id: product.id,
        quantity: product.quantity
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
  return commandData;
};

/** Résultat paiement Terminal (WisePad) — met à jour le statut côté serveur. */
exports.createCommand = createCommand;
const recordTerminalPaymentOutcome = async (command_id, outcome, stripe_payment_intent_id) => {
  const body = {
    command_id,
    outcome,
    ...(stripe_payment_intent_id ? {
      stripe_payment_intent_id
    } : {})
  };
  const res = await fetch(`${API_URI}/commands/terminal/payment-outcome`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.message || 'Erreur enregistrement du paiement');
  }
  return data;
};
exports.recordTerminalPaymentOutcome = recordTerminalPaymentOutcome;
const getPaymentLink = async command_id => {
  const response = await fetch(`${API_URI}/commands/${command_id}/payment-link`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });
  const responseData = await response.json();
  if (response.ok) {
    return responseData;
  } else {
    throw new Error(responseData.message);
  }
};
exports.getPaymentLink = getPaymentLink;